<div class="flex flex-1 gap-2 align-stretch column">
  @if (layers$ | async; as layers) {
    <!-- filter -->
    @if (layers) {
      <div class="map-container">
        <app-map [layers]="layers" [useMarkerCluster]="true" />

        <app-card class="map-legend" style="--spacing: 1rem">
          <h4>{{ "map.legend.title" | translate }}</h4>
          <ul>
            <li>
              <span class="pin default" aria-hidden="true"></span>
              {{ "map.legend.default" | translate }}
            </li>
            <li>
              <span class="pin favorite" aria-hidden="true"></span>
              {{ "map.legend.favorite" | translate }}
            </li>
            <li>
              <span class="pin out-of-service" aria-hidden="true"></span>
              {{ "map.legend.outOfService" | translate }}
            </li>
          </ul>
        </app-card>
      </div>
    }

    @if (selectedDevice$ | async; as device) {
      <app-map-device-detail
        class="device-detail"
        [device]="device"
        (closeDetail)="onCloseDetail()"
        (triggerDeviceAction)="onTriggerDeviceAction($event)"
      />
    }
  }
</div>
